import * as React from "react";

const AWSIcon = (props) => (
  <svg
    viewBox="0 0 100 100"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <clipPath id="a" />
    <g clipPath="url(#a)" fill="#9D5125">
      <path d="M85.245 58.712v2.615c0 .4-.029.799-.086 1.193v-2.613c.057-.396.086-.795.086-1.195M85.159 59.907v2.613c-.074.5-.189.996-.346 1.486v-2.613c.157-.492.272-.986.346-1.486M84.813 61.394v2.613a10.502 10.502 0 0 1-.812 1.861v-2.613c.336-.606.607-1.229.812-1.861M84.001 63.255v2.613c-2.23 4.035-7.223 7.25-13.012 7.25v-2.613c5.789 0 10.782-3.217 13.012-7.25" />
    </g>
    <path fill="#9D5125" d="m71.695 70.052-.706 3.066h-41.98l-.731-3.108z" />
    <clipPath id="b" />
    <g clipPath="url(#b)">
      <path
        d="M29.009 70.505v2.613c-7.875 0-14.254-5.928-14.254-11.791v-2.615c0 5.863 6.379 11.793 14.254 11.793"
        fill="#9D5125"
      />
    </g>
    <path
      d="M41.88 26.882c7.318 0 13.617 4.352 16.443 10.578a9.159 9.159 0 0 1 5.17-1.592c4.945 0 8.963 3.896 9.113 8.775 7.113.594 12.639 7.439 12.639 12.885v1.184c0 5.863-6.395 11.793-14.256 11.793h-41.98c-7.875 0-14.254-5.93-14.254-11.793v-1.184c0-4.502 3.801-10.717 9.137-12.238a5.75 5.75 0 0 1-.027-.525c-.001-9.879 8.064-17.883 18.015-17.883z"
      fill="#F58535"
    />
    <g fill="#FFF">
      <path d="m32.419 47.812-4.707 16.447h2.76l1.064-4.029h4.848l1.023 4.029h2.758l-4.359-16.447h-3.387zm-.393 10.322 1.973-8.111h.043l1.902 8.111h-3.918zM51.995 60.663h-.047l-2.226-12.851h-2.784l-2.177 12.783h-.049l-2.176-12.783h-2.668l3.197 16.447h3.063l2.111-12.391h.049l2.133 12.391h3.058l3.292-16.447h-2.622zM65.282 55.276l-1.785-.648c-1.762-.666-2.48-1.381-2.48-2.783 0-1.754 1.09-2.375 2.223-2.375 1.646 0 2.32.875 2.32 2.375v.346h2.646v-.373c0-1.701-.441-4.328-4.684-4.328-3.107 0-5.148 1.66-5.148 4.658 0 2.346 1.041 3.59 3.453 4.508l1.809.627c1.488.434 2.367 1.197 2.367 2.922 0 1.221-.838 2.398-2.506 2.398-1.828 0-2.711-1.016-2.711-3.018v-.418H58.14v.393c0 2.305.93 5.02 5.031 5.02 3.34 0 5.477-1.449 5.477-4.947-.001-2.261-1.024-3.53-3.366-4.357z" />
    </g>
  </svg>
);

export default AWSIcon;
